import { ReqParams } from "../types";
import axiosInstance from "./axiosInstance";

export default class TicketService {
  static async getAllList(params: ReqParams = {}) {
    const response = await axiosInstance.get("/agent/tickets", { params });
    return response.data;
  }

  static async getAssignedList(params: ReqParams = {}) {
    const response = await axiosInstance.get("/agent/assigned/tickets", { params });
    return response.data;
  }

  static async getDetails(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/agent/tickets/${params?.id}`, { params });
    return response.data;
  }

  static async getDetailsForChat(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/customer/ticket/${params?.ticketId}/${params?.chatbotId}`, { params });
    return response.data;
  }

  static async assign(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/agent/ticket/assign`, params);
    return response.data;
  }

  static async sendMailToCustomer(params: ReqParams | FormData = {}) {
    const id = params instanceof FormData ? params.get('id') : (params as ReqParams)?.id;
    const response = await axiosInstance.post(`/agent/ticket/status-update/email/${id}`, params);
    return response.data;
  }

  // Reply to a social-channel ticket (facebook / instagram / whatsappchat).
  // Body is multipart FormData: { message, attachments? } (attachments may repeat).
  static async replyToTicket(ticketId: string | number, formData: FormData) {
    const response = await axiosInstance.post(`/agent/tickets/${ticketId}/reply`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  static async updateStatus(params: ReqParams = {}) {
    const response = await axiosInstance.put(`/agent/ticket/status-update/${params?.id}`, params);
    return response.data;
  }

  static async updatePriority(params: ReqParams = {}) {
    const response = await axiosInstance.patch(`/agent/ticket/${params?.id}/priority`, params);
    return response.data;
  }

  static async updateCategory(params: ReqParams = {}) {
    const response = await axiosInstance.put(`/agent/ticket/category-update/${params?.id}`, params);
    return response.data;
  }

  static async addByChat(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/chatbot`, { ...params, source: 'chatbot' });
    return response.data;
  }

  static async addMannually(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/agent/tickets`, { params });
    return response.data;
  }

  static async getTicketCategoryDropdown() {
    const response = await axiosInstance.get("tenant/ticket-category-dropdown");
    return response.data;
  }

  static async getTicketSubCategoryDropdown(categoryId: number | string) {
    const response = await axiosInstance.get(`tenant/ticket-sub-category-dropdown/${categoryId}`);
    return response.data;
  }

  // Sub-sub-category dropdown: cascades from a chosen category + sub-category.
  // Path params: /{categoryId}/{subCategoryId}
  static async getTicketSubSubCategoryDropdown(categoryId: number | string, subCategoryId: number | string) {
    const response = await axiosInstance.get(`tenant/ticket-sub-sub-category-dropdown/${categoryId}/${subCategoryId}`);
    return response.data;
  }
}
